export const ASPECT_RATIO = {
  ARTICLE: 1.8,
  NO_RATIO: 0,
  SQUARE: 1,
  AWARD_IMAGE: 0.814,
  GRADIENT_BACKGROUND_IMAGE: 4.173,
  AWARD_STATUETTE_IMAGE: 0.7483,
  JUDGE_IMAGE_NEW: 1,
  JUDGE_IMAGE: 1.0852,
  NOMINEE_LOGO: 2.6,
  YOUTUBE_VIDEO: 1.88,
  HIGHLIGHT_IMAGE: 1.5
}

export const REQUIRED_DIMENSIONS_BY_RATIO = {
  '1.8': {
    minWidth: 900,
    minHeight: 500
  }
}

export function getDimensionsByRatio(ratio) {
  if (!ratio) return null

  return REQUIRED_DIMENSIONS_BY_RATIO[ratio.toString()] || null
}
